import { FormikHelpers } from 'formik';
import { ColourPicker, ColourPickerProps } from 'components/UI/ColourPicker';

export type FormColourPickerProps = ColourPickerProps & Pick<FormikHelpers<unknown>, 'setFieldValue'>;

const FormColourPicker = ({ setFieldValue, ...props }: FormColourPickerProps) => (
  <ColourPicker {...props} onChange={(name, value) => setFieldValue(name, value)} />
);

export { FormColourPicker };
